/* ----------------------------------------------------------------------------
switch between color themes and display modes
---------------------------------------------------------------------------- */
export default class ThemePicker extends HTMLElement {
	// constructor() {
	// 	super();
	// }

	connectedCallback() {
		const themeOptions = this.querySelectorAll('[theme-name]');
		themeOptions.forEach((button) => {
			button.addEventListener('click', this.applyTheme.bind(this));
		});
		document.addEventListener('click', this.onClickOutside.bind(this));
	}

	applyTheme({ target }) {
		const theme = target.getAttribute('theme-name');
		document.documentElement.setAttribute('theme', theme);

		// Style the controls
		this.querySelectorAll('[theme-name]').forEach((control) => {
			control.removeAttribute('aria-current');
		});
		this.querySelector(`[theme-name="${theme}"]`).setAttribute(
			'aria-current',
			'true',
		);

		// Store the theme
		localStorage.setItem('theme', theme);
	}

	onClickOutside(event) {
		// when the menu is already closed there's no open <details>, and nothing to do
		if (!this.contains(event.target)) {
			this.querySelector('details[open]')?.removeAttribute('open');
		}
	}
}

window.customElements.define('theme-picker', ThemePicker);
